
<div class="container" style="border:1px solid #bebaba">
  <br />

  <div class="row indentContent">
    <div class="col-md-12">
      <h3 style="font-weight:bold">Contact Us</h3>
      <p>If you have any questions that have not been answered by the information included on this website or in the Settlement Notice, please contact the Claims Administrator. </p>
      <p style="text-align:center">
        Non-Bank ATM Surcharge Settlement Helpline: 1-866-893-1052<br />
        By email: <a href="mailto:info@NonBankATMSurchargeSettlement.com">info@NonBankATMSurchargeSettlement.com</a><br /><br />

        Or in writing to:<br /><br />

        Non-Bank ATM Surcharge Fee Settlement<br />
        c/o A.B. Data, Ltd.<br />
        P.O. Box 173053<br />
        Milwaukee, WI 53217<br />
      </p>
    </div>
  </div>
  <div style="width:80%; margin:0 auto; text-align: center; display:block; margin-top: 2%">
    <p>
      Note: These documents are in PDF format. To view the<br />
      documents, you will need <a href="https://get.adobe.com/reader/" target="_blank"
                                  style="color:#0071ce; font-weight:bold">Adobe Acrobat Reader</a>
      on your computer or other internet-enabled device.
    </p>
  </div>
  <div class="row text-center" id="inverse_row">
    <div class="col-md-12">
      <a href="https://get.adobe.com/reader/" target="_blank"><img src="../assets/adobe-pdf-icon.jpg" alt="Adobe Acrobat Reader" width="3%"></a>
    </div>
  </div>
  <br />
</div>
